import {FormElementType} from "~/enums/formElementType";
import {InputFormatType} from "../../inputFormatType";
import FormElement from "../formElement";
import WorkflowStep from "../../workflow/workflowStep";
import Recipient from "../../workflow/recipient";
import {formElementsSchema, baseRestrictions, restrictionSchema} from "./thirdPartyCompleterSchema";
import TemplateElement from "./templateElement";


export default class ThirdPartyCompleter extends TemplateElement {
  layout_config: Array<number>;
  restrictionSchema: object = restrictionSchema;
  _elementRestrictions = [baseRestrictions];
  formElementsSchema = formElementsSchema;

  constructor() {
    super();
    this.defineProperty('layout_config', [1, 1, 1]);
  }

  get phoneElement(): FormElement {
    return this.formElementsArray.find(elem => elem.sort_order === 3);
  }

  get isRequestingPhone(): boolean {
    return !!this.phoneElement;
  }

  requestPhone(): void {
    if (!this.isRequestingPhone) {
      const phoneElement = new FormElement().initialize(this.rootModel, this, FormElementType.textField);
      phoneElement.rootModel = this.rootModel;
      phoneElement.parent = this;
      phoneElement.loadFromJson({label_title: 'Phone Number', sort_order: 3, is_required: true, format_type: InputFormatType.Phone});
      this.rootModel.placeInDictionary(phoneElement, phoneElement.rootName, this);
      this.trackCreationDeletion(phoneElement.client_id, null, phoneElement.asJson(), phoneElement);
      this.layout_config = [1, 1];
    }
  }

  stopRequestPhone(): void {
    if (this.isRequestingPhone) {
      this.phoneElement.destroy();
      this.layout_config = [1, 1, 1];
    }
  }

  get workflowStepsAsCompleter(): WorkflowStep[] {
    return this.rootModel.workflowStepsArray.filter(step => {
      return step.submitter.reference_id === this.client_id;
    });
  }

  get workflowStepPermittees(): WorkflowStep[] {
    const permittees = [];
    this.rootModel.workflowStepsArray.forEach(step => {
      const allWorkflowStepPermittees = [...step.dataViewersArray, ...step.statusViewersArray];
      const p = allWorkflowStepPermittees.filter(permittee => permittee.reference_id === this.client_id);

      permittees.push(...p);
    });
    return permittees;
  }

  get workflowStepNotificationRecipients(): Recipient[] {
    const recipients = [];
    this.rootModel.workflowStepsArray.forEach(step => {
      step.notificationsArray.forEach(notification => {
        const r = notification.recipientsArray.find(recipient => recipient.reference_id === this.client_id);
        if (r) {
          recipients.push(r);
        }
      });
    });
    return recipients;
  }

  afterDestroy() {
    super.afterDestroy();
    this.clearReferences();
  }

  clearReferences() {
    this.workflowStepsAsCompleter.forEach(ws => {
      ws.setSubmitterToOriginalSubmitter();
    });
    this.workflowStepPermittees.forEach(permittee => permittee.destroy());
    this.workflowStepNotificationRecipients.forEach(recipient => {
      if (recipient.notification.recipientsArray.length === 1) {
        // this third party is last recipient
        recipient.notification.destroy();
      } else {
        recipient.destroy();
      }
    });
  }
}
